import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]

  open() {
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.classList.remove("opacity-0")
    this.panelTarget.classList.remove("scale-95")
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.panelTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("scale-95")
    this.overlayTarget.classList.remove("flex")
    this.overlayTarget.classList.add("hidden")
  }

  stop(event) {
    event.stopPropagation()
  }
}
